import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { EmployeesPageComponent } from './employees-page.component';
import { FormsModule } from '@angular/forms';
import { EmployeeCardModule } from './employee-card/employee-card.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.employees',
    url: '/employees',
    component: EmployeesPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      loginParamsObject: null
    }
  }
];

@NgModule({
  declarations: [EmployeesPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    EmployeeCardModule,
    InfiniteScrollModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [EmployeesPageComponent],
  entryComponents: [EmployeesPageComponent]
})
export class EmployeesPageModule { }
